<template>
  <div class="app" @click="opens">
    立即报名
  </div>
</template>
<script>
export default {
 props:{
   apply_url:String
 },
 methods:{
   opens(){
     window.open(this.apply_url)
   }
 }
}
</script>
<style src="../../style/my.css" scoped></style>
<style scoped>
.app{
   width: 100%;
   max-width: 750px;
   /* margin: 12px auto 0; */
   margin: 0 auto;
   height: 0.93rem;
   font-size: 0.3rem;
   line-height: 0.93rem;
   cursor: pointer;
   background:#CDAA74;
   text-align: center;
   color: #fff;
   position: fixed;
   bottom: 0;
   left:0
}
</style>



// WEBPACK FOOTER //
// src/view/common/apply.vue